// src/components/Landing/FeatureCard.jsx
import React from 'react';
import { motion } from 'framer-motion';

export const FeatureCard = ({ icon, title, body, index }) => {
  return (
    <motion.div
      className="p-6 rounded-2xl bg-white/10 dark:bg-white/5 border border-white/10
                 backdrop-blur-xl shadow-lg cursor-pointer"
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay: index * 0.12 }}
      whileHover={{
        y: -6,
        scale: 1.02,
        boxShadow: '0 10px 35px rgba(255,255,255,0.12)',
      }}
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/10 border border-white/10 mb-4">
        <span className="text-2xl">{icon}</span>
      </div>

      <h4 className="font-semibold text-lg text-slate-900 dark:text-white mb-2">{title}</h4>

      <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">{body}</p>
    </motion.div>
  );
};
